export const permissionsSchema = {
  $schema: 'http://json-schema.org/schema#',
  $id: 'botConfigSettingsSchema.json',

  type: 'object',
  title: 'Permissions',
  properties: {
    tokens: {
      type: 'array',
      title: 'Tokens for access',
      description:
        'List of pre-generated tokens for share-by-link feature with corresponding access roles',
      items: {
        type: 'object',
        properties: {
          token: {
            type: 'string',
            title: 'Token',
            pattern: '^[a-f0-9]*$',
            maxLength: 40,
            minLength: 40
          },
          role: {
            title: 'Role',
            type: 'string',
            enum: ['view', 'comment', 'copywrite', 'edit']
          },
          name: {
            type: 'string',
            title: 'Name'
          },
          analytics: {
            type: 'boolean',
            title: 'Analytics'
          },
          callsList: {
            type: 'boolean',
            title: 'Conversations list'
          }
        },
        required: ['token', 'role']
      }
    },
    users: {
      type: 'array',
      title: 'Users with access',
      description: 'List of email users and corresponding roles with access to given bot',
      items: {
        type: 'object',
        properties: {
          email: {
            type: 'string',
            title: 'Email',
            format: 'email'
          },
          role: {
            title: 'Role',
            type: 'string',
            enum: ['view', 'comment', 'copywrite', 'edit']
          },
          analytics: {
            type: 'boolean',
            title: 'Analytics'
          },
          callsList: {
            type: 'boolean',
            title: 'Conversations list'
          }
        },
        required: ['email', 'role']
      }
    }
  }
} as const

export const uiSchema = {
  'ui:classNames': 'e2e-permissions',
  'ui:title': false,

  tokens: {
    items: {
      'ui:label': false,
      token: {
        'ui:widget': 'CopyLinkWidget',
        'ui:readonly': true,
        generateToken: true
      },
      analytics: {
        'ui:classNames': 'form-checkbox-move-right-by-column'
      },
      callsList: {
        'ui:classNames': 'form-checkbox-move-right-by-column'
      }
    }
  },
  users: {
    items: {
      'ui:label': false,
      email: {
        'ui:classNames': 'users-with-access-email'
      },
      role: {
        'ui:classNames': 'users-with-access-role'
      },
      analytics: {
        'ui:classNames': 'form-checkbox-move-right-by-column'
      },
      callsList: {
        'ui:classNames': 'form-checkbox-move-right-by-column'
      }
    }
  }
} as const
